import { useEffect, useState } from 'react';
import { getRedemptions } from '@/api/member';
import { MEMBER_HISTORY_PAGE_SIZE_MAX } from '@shared/input-validation';

const EMPTY: ReadonlySet<string> = new Set();

/**
 * 当前会员已成功领取过的主题名称集合，用于列表“已领取”标记和“只看未领取”。
 * 复用会员自己的领取记录接口，登录后取一次；领取成功会跳到成功页，
 * 返回列表时页面重新挂载，自然会再取一次最新记录。
 * 读取失败时静默返回空集合，不影响浏览和领取主流程。
 */
export function useClaimedTopics(passcode: string | null | undefined): ReadonlySet<string> {
  const [claimed, setClaimed] = useState<ReadonlySet<string>>(EMPTY);

  useEffect(() => {
    if (!passcode) {
      setClaimed(EMPTY);
      return;
    }

    let cancelled = false;
    getRedemptions({ passcode, pageSize: MEMBER_HISTORY_PAGE_SIZE_MAX })
      .then((result) => {
        if (cancelled) return;
        const names = new Set<string>();
        for (const record of result.items) {
          if (record.record_type !== 'quota_adjustment' && record.result === 'success' && record.topic_name) {
            names.add(record.topic_name);
          }
        }
        setClaimed(names);
      })
      .catch(() => {
        if (!cancelled) setClaimed(EMPTY);
      });

    return () => {
      cancelled = true;
    };
  }, [passcode]);

  return claimed;
}
